/*
 * 投票接口
 * */
import services from "../config/axios";
import base from './base';
// 定义参数类型
type paramsType<T> = {
  [key: string]: T;
};

const voteAPI = {
  // 获取当前投票列表
  getVoteCurrentList<T>(params: FormData) {
    return services.post(`${base.lk}/Vote/GetVoteCurrentList`, params);
  },
  // 获取当前投票标题
  getVoteCurrentHead<T>(params: FormData) {
    return services.post(`${base.lk}/Vote/GetVoteCurrentHead`, params);
  },
  //投票
  thumbsUp<T>(params:FormData){
    return services.post(`${base.lk}/Vote/ThumbsUp`, params);
  },
  getChartData<T>(params:FormData){
    return services.post(`${base.lk}/Vote/GetChartData`, params);
  }
};

export default voteAPI;
